import { faCircleCheck, faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import Loader from "../Loader";
import MultipleForm from "./MultipleForm";
import { useTranslation } from "react-i18next";

export default function Form({
  submitFunction,
  formContent,
  schema,
  title,
  action,
  setHoldingSelected,
  notConfirmMessage,
  stateQueryRow,
  color
}) {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const [formData, setFormData] = useState([]);
  const [formOpen, setFormOpen] = useState(false);
  const [createdMessage, setCreatedMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  if (stateQueryRow !== undefined) {
    notConfirmMessage = true;
  }

  useEffect(() => {
    setFormData(formContent);
  }, [formContent]);

  const { register, handleSubmit, formState, reset } = useForm({
    mode: "onBlur",
    resolver: yupResolver(schema),
  });

  const { errors } = formState;
  const onInvalid = (errors) => {
    for (let key in errors) {
      setErrorMessage(errors[key].message);
    }
  };

  const { mutate, isSuccess, isError, isPending, error } = useMutation({
    mutationFn: (data) => submitFunction(data),
    onSuccess: () => {
      queryClient.invalidateQueries();
      setCreatedMessage(action === "new" ? "Créé" : "Modifié");
      if (notConfirmMessage) {
        handleFormClose();
      }
    },
  });

  const handleFormClose = () => {
    setFormOpen(false);
    setCreatedMessage("");
    if (setHoldingSelected !== undefined) {
      setHoldingSelected(null);
    }
    reset();
  };

  if (schema._nodes[0] === "entreprise") {
    return (
      <div className="menu-dropdown">
        <button
          className={`buttons-ecp ${color === true ? "buttons-ecp-new" : "buttons-ecp-" + action }`}
          onClick={() => {
            setFormOpen(true);
          }}
        >
          {t(title)}
        </button>
        {isPending ? (
          <div className={`dialog-form ${formOpen && "dialog-form_open"}`}>
            <Loader />
          </div>
        ) : (
          <>
            <div className={`overlay ${formOpen ? "overlay_open" : ""}`} onClick={handleFormClose}></div>
            <div className={`dialog-form ${formOpen ? "dialog-form_open" : ""}`}>
              <button
                className="button button-delete dialog-form_close"
                onClick={handleFormClose}
              >
                <FontAwesomeIcon icon={faClose} />
              </button>
              <div className="dialog-form_content">
                {createdMessage ? (
                  <div className="dialog-form_success">
                    <FontAwesomeIcon
                      icon={faCircleCheck}
                      className="dialog-form_success-icon"
                    />
                    <h2>{t(createdMessage)}</h2>
                  </div>
                ) : (
                  <MultipleForm
                    handleSubmit={handleSubmit}
                    mutate={mutate}
                    onInvalid={onInvalid}
                    register={register}
                    formData={formData}
                    isError={isError}
                    errors={errors}
                    error={error}
                    action={action}
                    title={title}
                  />
                )}
              </div>
            </div>
          </>
        )}
      </div>
    );
  } else {
    return (
      <>
        {isPending ? (
          <div className={`dialog-form ${formOpen && "dialog-form_open"}`}>
            <Loader />
          </div>
        ) : (
          <>
            <div className={`overlay ${formOpen ? "overlay_open" : ""}`} onClick={handleFormClose}></div>
            <div className={`dialog-form ${formOpen ? "dialog-form_open" : ""}`}>
              <button
                className="button button-delete dialog-form_close"
                onClick={handleFormClose}
              >
                <FontAwesomeIcon icon={faClose} />
              </button>
              <div className="dialog-form_content">
                {createdMessage ? (
                  <div className="dialog-form_success">
                    <FontAwesomeIcon
                      icon={faCircleCheck}
                      className="dialog-form_success-icon"
                    />
                    <h2>{t(createdMessage)}</h2>
                  </div>
                ) : (
                  <MultipleForm
                    handleSubmit={handleSubmit}
                    mutate={mutate}
                    onInvalid={onInvalid}
                    register={register}
                    formData={formData}
                    isError={isError}
                    errors={errors}
                    error={error}
                    action={action}
                    title={title}
                  />
                )}
              </div>
            </div>
          </>
        )}
        <button
          className={`buttons-ecp ${color === true ? "buttons-ecp-new" : "buttons-ecp-" + action }`}
          onClick={() => {
            setFormOpen(true);
          }}
        >
          {t(title)}
        </button>
      </>
    );
  }
}
